/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment } from 'react';
import PartnerProjectCard from '../../shared/cards/PartnerProjectCardAll';
const PartnerProjectsAllContent = ({ items }) => {
    function renderCard(item) {
        const ItemComponent = PartnerProjectCard;
        return React.createElement(ItemComponent, { ...item, key: item.id });
    }
    return React.createElement(Fragment, null, items.map((item) => renderCard(item)));
};
export default PartnerProjectsAllContent;
